import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showAlert } from "../../../../reducer/alertSlice";

export default function AccessDenied({to = -1}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(showAlert({
            msg: "접근 권한이 없습니다.",
            func: () => {
                navigate(to);
            }
        }))
    },[])
    
    return;
}